<div *ngIf="videoUrl" class="video-overlay" [ngClass]="isPlaying ? '' : 'invisible'"></div>
<div *ngIf="videoUrl" class="vid-container" [ngClass]="isPlaying ? '' : 'invisible'">
  <video
    id="adVideo"
    #video
    *ngIf="videoUrl"
    muted
    playsinline
    webkit-playsinline
    [defaultMuted]="true"
    (loadedmetadata)="video.muted=true;video.playsInline=true;startVideo($event); "
  >
    <source src="{{ videoUrl }}" type="{{ mime }}" />
    Your browser does not support the video tag.
  </video>

  <span *ngIf="videoUrl" class="material-symbols-outlined close-btn" (click)="endVideo()">close</span>
</div>
